export default {
    menu: {
        home: 'หน้าแรก',
        about_us: 'เกี่ยวกับเรา',
        our_services: 'บริการของเรา',
        products: 'ผลิตภัณฑ์',
        news: 'ข่าวสาร',
        investor_relations: 'นักลงทุนสัมพันธ์',
        contact_us: 'ติดต่อเรา',
    },
    content: {
        home: {
            title: 'ผู้ผลิตอาหารสัตว์คุณภาพสูง',
            subtitle: 'โภชนาการคุณภาพสำหรับสัตว์เลี้ยงที่คุณรัก',
            hero: {
                title: 'ยินดีต้อนรับสู่ PETPAL Products',
                subtitle: 'ผู้ผลิตอาหารสัตว์คุณภาพสูง',
            },
            banners: {
                title: 'แบนเนอร์ของเรา',
                learn_more: 'เรียนรู้เพิ่มเติม',
            },
            products: {
                title: 'ผลิตภัณฑ์แนะนำ',
                subtitle: 'ค้นพบผลิตภัณฑ์อาหารสัตว์ที่ขายดีและเป็นที่รักมากที่สุดของเรา',
                view_details: 'ดูรายละเอียด',
            },
            news: {
                title: 'ข่าวสารล่าสุด',
                subtitle: 'ติดตามข่าวสารและบทความล่าสุดจาก PETPAL',
                read_more: 'อ่านเพิ่มเติม',
            },
            categories: {
                title: 'หมวดหมู่ผลิตภัณฑ์',
                subtitle: 'สำรวจหมวดหมู่อาหารสัตว์ที่หลากหลายของเรา',
            },
            cta: {
                title: 'พร้อมทำงานกับเราแล้วหรือยัง?',
                subtitle: 'ติดต่อทีมของเราวันนี้',
                button: 'ติดต่อเรา',
            },
        },
        mission: [
            'พัฒนาคุณภาพของผลิตภัณฑ์ให้มีคุณภาพอย่างต่อเนื่อง',
            'พัฒนาระบบในการจัดส่ง เพื่อส่งมอบให้ครบถ้วนและทันเวลา',
            'พัฒนาประสิทธิภาพของกระบวนการผลิตอย่างเหมาะสม',
            'รักษาไว้ซึ่งระบบบริหารคุณภาพและความปลอดภัยด้านอาหารสัตว์ โดยยึดถือความพึงพอใจของลูกค้าเป็นสำคัญ',
        ],
    },
    about: {
        hero: {
            title: 'เกี่ยวกับ PETPAL Products',
            subtitle: 'ผู้ผลิตอาหารสัตว์ชั้นนำด้วยมาตรฐานคุณภาพระดับสากล',
        },
        overview: {
            title: 'ภาพรวมบริษัท',
            subtitle: 'เรียนรู้เพิ่มเติมเกี่ยวกับบริษัทของเรา',
            description: 'PETPAL Products เป็นผู้ผลิตอาหารสัตว์ชั้นนำด้วยมาตรฐานคุณภาพระดับสากล',
            vision: {
                title: 'วิสัยทัศน์ของเรา',
                description: 'เป็นผู้ผลิตอาหารสัตว์ชั้นนำในประเทศไทยและเอเชียตะวันออกเฉียงใต้',
            },
            mission: {
                title: 'พันธกิจของเรา',
                description: 'จัดหาผลิตภัณฑ์อาหารสัตว์คุณภาพสูงที่ตรงตามมาตรฐานสากล',
            },
        },
        values: {
            title: 'ค่านิยมของเรา',
            subtitle: 'หลักการที่ชี้นำการทำงานของเรา',
            quality: {
                title: 'คุณภาพ',
                description: 'เรายึดมั่นในมาตรฐานสูงสุดในทุกผลิตภัณฑ์',
            },
            trust: {
                title: 'ความไว้วางใจ',
                description: 'เราสร้างความสัมพันธ์ที่ยั่งยืนกับลูกค้า',
            },
            innovation: {
                title: 'นวัตกรรม',
                description: 'เราปรับปรุงผลิตภัณฑ์และกระบวนการอย่างต่อเนื่อง',
            },
            sustainability: {
                title: 'ความยั่งยืน',
                description: 'เรามุ่งมั่นในความรับผิดชอบต่อสิ่งแวดล้อม',
            },
        },
        history: {
            title: 'ประวัติของเรา',
            subtitle: 'เส้นทางสู่การเป็นผู้ผลิตอาหารสัตว์ชั้นนำ',
            founded: {
                title: 'ก่อตั้งบริษัท',
                description: 'PETPAL Products ก่อตั้งขึ้นด้วยวิสัยทัศน์ในการจัดหาอาหารสัตว์คุณภาพ',
            },
            expansion: {
                title: 'ขยายตลาด',
                description: 'เราขยายการดำเนินงานเพื่อให้บริการลูกค้าทั่วประเทศไทย',
            },
            innovation: {
                title: 'นวัตกรรมผลิตภัณฑ์',
                description: 'เราเปิดตัวผลิตภัณฑ์ใหม่ด้วยสูตรที่ก้าวหน้า',
            },
            growth: {
                title: 'การเติบโตอย่างรวดเร็ว',
                description: 'เราได้บรรลุการเติบโตและการยอมรับในตลาดอย่างมีนัยสำคัญ',
            },
        },
        cta: {
            title: 'พร้อมทำงานกับเราแล้วหรือยัง?',
            subtitle: 'ติดต่อทีมของเราวันนี้',
            button: 'ติดต่อเรา',
        },
    },
    products: {
        title: 'ผลิตภัณฑ์ของเรา',
        subtitle: 'ค้นพบผลิตภัณฑ์อาหารสัตว์คุณภาพสูงของเรา',
        filters: {
            all_categories: 'หมวดหมู่ทั้งหมด',
            newest: 'ใหม่ล่าสุด',
            name: 'ชื่อ',
            updated: 'อัพเดท',
        },
        showing: 'แสดง {count} จาก {total} ผลิตภัณฑ์',
        no_products: {
            title: 'ไม่พบผลิตภัณฑ์',
            description: 'ลองปรับตัวกรองหรือกลับมาดูผลิตภัณฑ์ใหม่ในภายหลัง',
        },
    },
    news: {
        title: 'ข่าวสารล่าสุด',
        subtitle: 'ติดตามข่าวสารและอัพเดทล่าสุดของเรา',
        filters: {
            all_categories: 'หมวดหมู่ทั้งหมด',
            latest: 'ล่าสุด',
            title: 'หัวข้อ',
            created: 'สร้าง',
        },
        showing: 'แสดง {count} จาก {total} บทความ',
        no_news: {
            title: 'ไม่พบข่าวสาร',
            description: 'ลองปรับตัวกรองหรือกลับมาดูบทความใหม่ในภายหลัง',
        },
    },
    common: {
        read_more: 'อ่านเพิ่มเติม',
        no_image: 'ไม่มีรูปภาพ',
        featured: 'แนะนำ',
        view_details: 'ดูรายละเอียด',
    },
    custom: {
        contact: {
            title: 'ติดต่อเรา',
            subtitle: 'เราพร้อมให้บริการและตอบคำถามทุกข้อสงสัย',
            description: 'หากท่านมีข้อสงสัยหรือต้องการข้อมูลเพิ่มเติมเกี่ยวกับผลิตภัณฑ์และบริการของเรา กรุณาติดต่อเราผ่านช่องทางต่างๆ ด้านล่าง',
            head_office: 'สำนักงานใหญ่',
            factory: 'โรงงาน',
            phone: 'โทรศัพท์',
            email: 'อีเมล',
            address: 'ที่อยู่',
            map: 'แผนที่',
            contact_form: {
                title: 'ส่งข้อความถึงเรา',
                subtitle: 'กรอกข้อมูลด้านล่างเพื่อส่งข้อความถึงเรา',
                name: 'ชื่อ-นามสกุล',
                name_placeholder: 'กรุณากรอกชื่อ-นามสกุล',
                email: 'อีเมล',
                email_placeholder: 'กรุณากรอกอีเมล',
                phone: 'เบอร์โทรศัพท์',
                phone_placeholder: 'กรุณากรอกเบอร์โทรศัพท์',
                company: 'บริษัท/องค์กร',
                company_placeholder: 'กรุณากรอกชื่อบริษัท/องค์กร (ไม่บังคับ)',
                subject: 'หัวข้อ',
                subject_placeholder: 'กรุณากรอกหัวข้อข้อความ',
                message: 'ข้อความ',
                message_placeholder: 'กรุณากรอกข้อความที่ต้องการส่งถึงเรา',
                submit: 'ส่งข้อความ',
                sending: 'กำลังส่ง...',
                success: 'ส่งข้อความสำเร็จ! เราจะติดต่อกลับในเร็วๆ นี้',
                error: 'เกิดข้อผิดพลาดในการส่งข้อความ กรุณาลองใหม่อีกครั้ง'
            },
            newsletter: {
                title: 'รับข่าวสารจากเรา',
                subtitle: 'สมัครรับข่าวสารและข้อมูลอัพเดทล่าสุดจาก PETPAL',
                email_placeholder: 'กรุณากรอกอีเมลเพื่อรับข่าวสาร',
                subscribe: 'สมัครรับข่าวสาร',
                subscribing: 'กำลังสมัคร...',
                success: 'สมัครรับข่าวสารสำเร็จ!',
                error: 'เกิดข้อผิดพลาดในการสมัคร กรุณาลองใหม่อีกครั้ง'
            },
            office_hours: 'เวลาทำการ',
            office_hours_value: 'จันทร์ - เสาร์: 08:00 - 17:00 น.',
            response_time: 'เวลาตอบกลับ',
            response_time_value: 'ภายใน 24 ชั่วโมง',
            get_directions: 'ดูเส้นทาง',
            call_now: 'โทรเลย',
            send_email: 'ส่งอีเมล'
        }
    }
};